import Section from '../ui/Section'
import { Display, Statement, Body, Points, Accent } from '../ui/Type'

const SAME = ['Hardware', 'Model', 'Workload', 'Quality requirement']

const MEASURE = [
  'Throughput',
  'TTFT',
  'Latency',
  'Concurrency',
  'Memory',
  'Utilization',
  'Completion time',
  'Infrastructure cost',
]

export default function Benchmark() {
  return (
    <Section id="benchmark" label="The benchmark">
      <Display>
        Same workload. Same quality.
        <br />
        <Accent>Prove the difference.</Accent>
      </Display>

      <Body className="mt-8">
        Bring LiquidBrain a real production workload. Define the environment. Define success. Then measure what matters.
      </Body>

      <div className="mt-14 grid grid-cols-1 gap-x-12 gap-y-12 sm:grid-cols-2">
        <div>
          <div className="border-t border-[var(--line-2)] pt-5 font-mono text-[11.5px] tracking-[0.14em] text-[var(--faint)] uppercase">
            Held constant
          </div>
          <Points className="mt-6" items={SAME} />
        </div>
        <div>
          <div className="border-t border-[var(--ink-blue)] pt-5 font-mono text-[11.5px] tracking-[0.14em] text-[var(--ink-blue)] uppercase">
            Measured
          </div>
          <Points className="mt-6" items={MEASURE} />
        </div>
      </div>

      <Statement className="mt-[5.5rem]">Can LiquidBrain produce materially more useful AI work?</Statement>
      <Body className="mt-6">That's the benchmark.</Body>
    </Section>
  )
}
